import Vue from "vue";
import VueClipboard from "vue-clipboard2";
// 一键复制
Vue.use(VueClipboard);
